import * as React from "react";
import { forwardRef } from "react";
const SvgAll = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, rx: 12, fill: "#6192BE" }), /* @__PURE__ */ React.createElement("path", { d: "M9.66675 12.2828L12.1419 14.7579L17.091 9.80823M6.75 12.2828L9.22515 14.7579M14.1749 9.80823L12.2918 11.7082", stroke: "white", strokeWidth: 1.1667, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgAll);
export { ForwardRef as ReactComponent };
